import React from 'react';

/** Horizontal 0–100 coachability score meter. */
export default function ScoreMeter({ label, value = 0, max = 100, tone = 'science', showValue = true, size = 'md', style, ...rest }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  const fill = tone === 'human' ? 'var(--human-400)' : tone === 'ink' ? 'var(--neutral-900)' : 'var(--science-400)';
  const h = size === 'sm' ? 8 : size === 'lg' ? 16 : 12;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, ...style }} {...rest}>
      {(label || showValue) && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          {label && (
            <span style={{
              fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-medium)', fontSize: 'var(--text-sm)',
              letterSpacing: 'var(--track-tight)', color: 'var(--ink)',
            }}>{label}</span>
          )}
          {showValue && (
            <span style={{
              fontFamily: 'var(--font-display)', fontWeight: 'var(--w-bold)', fontSize: 'var(--text-h4)',
              letterSpacing: 'var(--track-tight)', color: 'var(--ink)',
            }}>{value}</span>
          )}
        </div>
      )}
      <div style={{ height: h, borderRadius: 'var(--radius-pill)', background: 'var(--neutral-100)', overflow: 'hidden' }}>
        <div style={{
          width: pct + '%', height: '100%', background: fill,
          borderRadius: 'var(--radius-pill)', transition: 'width var(--dur-slow) var(--ease-out)',
        }} />
      </div>
    </div>
  );
}
